import { Component, inject, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';

import { LocalStorageService } from 'src/app/core/services/local-storage.service';

interface IChangeStayData {
  numDays: number;
  diffDays: number;
  cityName: string;
  newEndDate: string;
  isOptimizedMode: boolean;
}

const SAVE_SELECTED_OPTION = 'RP-saveSelectedOption';
const SELECTED_MAINTAIN_DURATION = 'RP-selectedMaintainDuration';

@Component({
    selector: 'app-change-stay-dialog',
    imports: [MatCheckbox, FormsModule],
    templateUrl: './change-stay-dialog.component.html',
    styleUrl: './change-stay-dialog.component.scss'
})
export class ChangeStayDialogComponent {
  maintainDuration: boolean = false;
  saveSelectedOption: boolean = false;
  changedDurationText: string = '';

  #localStorageService = inject(LocalStorageService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IChangeStayData,
    public dialogRef: MatDialogRef<ChangeStayDialogComponent>,
  ) {
    this.setChangedDurationText();
    if (this.data && this.data.isOptimizedMode) {
      this.saveSelectedOption = this.#localStorageService.getLocalStorage(
        SAVE_SELECTED_OPTION,
        false,
      );

      if (this.saveSelectedOption) {
        this.maintainDuration = this.#localStorageService.getLocalStorage(
          SELECTED_MAINTAIN_DURATION,
          false,
        );
      }
    }
  }

  onMaintainDurationHandler(maintain: boolean): void {
    this.maintainDuration = maintain;
    this.#localStorageService.setLocalStorage(
      SELECTED_MAINTAIN_DURATION,
      maintain,
    );
  }

  onSaveSelectedOptionHandler(): void {
    this.#localStorageService.setLocalStorage(
      SAVE_SELECTED_OPTION,
      this.saveSelectedOption,
    );
  }

  closeModal(body: { res: boolean; maintain: boolean }): void {
    this.dialogRef.close(body);
  }

  private setChangedDurationText(): void {
    if (this.data && this.data.diffDays) {
      const diff: number = this.data.diffDays;
      const adjustBy: string = diff < 0 ? 'reduced' : 'extended';
      const absDiff: number = Math.abs(diff);
      const dayOrDays: string = absDiff === 1 ? 'day' : 'days';
      this.changedDurationText = `${adjustBy} by ${absDiff} ${dayOrDays}`;
    }
  }
}
